"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var reactModal_1 = __importDefault(require("../../components/reactModal"));
var Button_1 = __importDefault(require("../ui-components/Button"));
var logo_1 = __importDefault(require("../assets/logo"));
var Authorize = function (_a) {
    var username = _a.username, email = _a.email, communityName = _a.communityName, communityId = _a.communityId, termsConditions = _a.termsConditions, clientId = _a.clientId, csrfToken = _a.csrfToken;
    var zapierApp = 'Zapier';
    return (preact_1.h(reactModal_1.default, { className: 'authorization-modal', isOpen: true },
        preact_1.h("h3", { className: 'authorization-modal_title' },
            preact_1.h("span", { className: 'authorization-modal_client-app-name' },
                " ",
                zapierApp,
                " "),
            " wants to access your ",
            communityName,
            " account"),
        preact_1.h("div", { className: 'authorization-modal_message' },
            preact_1.h("div", { className: 'authorization-modal_logo' },
                preact_1.h(logo_1.default, { width: '150', height: '50', customClass: 'authorization-modal_logo' })),
            preact_1.h("div", { className: 'authorization-modal_user-data' },
                preact_1.h("h6", null,
                    " This will allow ",
                    preact_1.h("span", { className: 'authorization-modal_client-app-name' },
                        " ",
                        zapierApp,
                        " "),
                    " to access:"),
                preact_1.h("p", null, email),
                preact_1.h("p", null, username)),
            preact_1.h("div", { className: 'authorization-modal_additional-information' },
                preact_1.h("h6", { style: 'font-weight:bold' },
                    " Make sure you trust ",
                    preact_1.h("span", { className: 'authorization-modal_client-app-name' },
                        " ",
                        zapierApp,
                        " ")),
                preact_1.h("p", null,
                    " Some more information on why you should make sure to trust ",
                    zapierApp))),
        preact_1.h("div", { className: 'authorization-modal_buttons' },
            preact_1.h("form", { action: '/oauth/accessCode', method: 'POST' },
                preact_1.h("input", { type: 'hidden', name: 'client_id', value: clientId }),
                preact_1.h("input", { type: 'hidden', name: 'yip_csrf_token', value: csrfToken }),
                preact_1.h(Button_1.default, { primary: true, type: 'submit', loading: false, disabled: false, style: { width: '150px' }, title: 'Authorize' }),
                preact_1.h(Button_1.default, { secondary: true, loading: false, disabled: false, onClick: function () { return window.history.go(-1); }, style: { 'margin-left': '10px', width: '150px' }, title: 'Cancel' }))),
        preact_1.h("div", { className: 'authorization-modal_privacy-terms' },
            preact_1.h("a", { className: 'authorization-modal-terms-link', href: termsConditions, target: '_blank' },
                " ",
                communityName,
                " privacy policy"))));
};
exports.default = Authorize;
